import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import reportWebVitals from './reportWebVitals';
import "./ASSETS/CSS/main.css";

import "bootstrap/dist/css/bootstrap.min.css";

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";

// import "antd/dist/antd.css";
import RoutesMain from './ROUTES/main';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
      <RoutesMain />
  </React.StrictMode>
);


reportWebVitals();
